import React, { useState } from "react";
import { Form, Input, Rate, Button, Result, Row, Col, Typography, Card } from "antd";
import { CheckCircleFilled, SendOutlined } from "@ant-design/icons";
import RatingService from "../../services/RatingService";

const { Title, Text } = Typography;

const UserEmailRate = () => {
  const [form] = Form.useForm();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Handle submit logic remains same
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        id: 0,
        userId: 0,
        rating: values.rating,
        reviewText: values.feedback,
        email: values.email,
        name: values.name 
      };
      await RatingService.submitRating(payload);
      setIsSubmitted(true);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAndRedirect = () => {
    window.location.href = "https://stusphere.org/";
  };

  const inputStyle = {
    borderRadius: "12px",
    border: "1px solid #e8e8e8",
    background: "#f8f9fa", 
    padding: "12px 7px",
    fontSize: "16px"
  };

  return (
    <div className="ur-overlay">
      <Card 
        className="ur-modal-responsive" 
        bordered={false}
      >
        {!isSubmitted ? (
          <>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <img src="/images/logo-header.png" alt="logo" style={{ maxWidth: '240px' }} />
            </div>

            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Title level={3} style={{ marginBottom: 4, fontWeight: 800 }}>We value your feedback</Title>
              <Text type="secondary">Help us improve the Stusphere experience.</Text>
            </div>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              requiredMark={false}
            >
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="name"
                    label={<Text strong>Full Name</Text>}
                    rules={[{ required: true, message: 'Name is required' }]}
                  >
                    <Input placeholder="Your name" style={inputStyle} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="email"
                    label={<Text strong>Email Address</Text>}
                    rules={[
                      { required: true, message: 'Email is required' },
                      { type: 'email', message: 'Enter a valid email' }
                    ]}
                  >
                    <Input placeholder="email@domain.com" style={inputStyle} />
                  </Form.Item>
                </Col>
              </Row>

              <div className="rating-container">
                <Form.Item
                  name="rating"
                  label={<Text strong>Overall Rating</Text>}
                  className="rate-stars"
                >
                  <Rate style={{ fontSize: 'clamp(30px, 8vw, 42px)', color: '#faad14' }} defaultValue={1}/>
                </Form.Item>
              </div>

              <Form.Item
                name="feedback"
                label={<Text strong>Your Message</Text>}
                rules={[{ required: true, message: 'Please write a brief review' }]}
              >
                <Input.TextArea 
                  rows={4} 
                  placeholder="What can we do better?" 
                  style={{ ...inputStyle, resize: 'none' }}
                />
              </Form.Item>

              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                icon={<SendOutlined />}
                block
                className="submit-btn feedback-submit-btn"
              >
                Submit Feedback
              </Button>
            </Form>
          </>
        ) : (
          <Result
            status="success"
            title="Feedback Submitted!"
            subTitle="Thank you for your time. Your input is valuable to us."
            extra={[
              <Button 
                type="primary" 
                key="home" 
                onClick={handleCloseAndRedirect} 
                className="submit-btn"
                style={{ width: 'auto', padding: '0 40px', marginRight: "10px"}}
              >
                Go to Website
              </Button>,
            ]}
          />
        )}
      </Card>
    </div>
  );
};

export default UserEmailRate;